import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class FavoritesService {
  favoriteItems = new BehaviorSubject<any[]>([]);
  storage = inject(StorageService);

  constructor() {
    const localFavorites = this.localFavorites;
    if (localFavorites) {
      this.favoriteItems.next(localFavorites);
    }
  }

  getFavoriteItems(): Observable<any> {
    return this.favoriteItems.asObservable();
  }

  get localFavorites() {
    // return sessionStorage.getItem("favorites");
    return this.storage.getItem<any>("favorites");
  }

  setFavorites(items: any[]) {
    // console.log(items);
    this.favoriteItems.next(items);
    this.setLocalFavorites(items);
  }

  setLocalFavorites(items: any[]) {
    // sessionStorage.setItem("favorites", JSON.stringify(items));
    this.storage.setItem("favorites", items);
  }

  add(item: any, type: string) {
    // console.log(item, type);
    if (this.isParent(type)) {
      if (!this.parentExists(item.id)) {
        this.setFavorites([...this.favoriteItems.value, item]);
      }
    } else {
      const marketParents = item.parents;
      const immediateParent = marketParents?.[marketParents.length - 1];
      if (!this.marketExists(item)) {
        if (this.parentExists(immediateParent.id)) {
          const newItems = this.favoriteItems.value.map((x: any) => {
            if (x.id === immediateParent.id) {
              return {
                ...x,
                markets: x.markets ? [...x.markets, item] : [item],
              };
            }
            return x;
          });
          this.setFavorites(newItems);
        } else {
          const newItems = [
            ...this.favoriteItems.value,
            {
              ...immediateParent,
              markets: [item],
            },
          ];
          this.setFavorites(newItems);
        }
      }
    }
  }

  remove(item: any, type: string) {
    if (this.isParent(type)) {
      const newItems = this.favoriteItems.value.filter((x: any) => x.id !== item.id);
      this.setFavorites(newItems);
    } else {
      const marketParents = item.parents;
      const immediateParent = marketParents?.[marketParents.length - 1];
      const newItems = this.favoriteItems.value.map((x: any) => {
        if (x.id === immediateParent.id) {
          return {
            ...x,
            markets: x.markets.filter((market: any) => market.id !== item.id),
          };
        }
        return x;
      });
      this.setFavorites(newItems);
    }
  }

  removeAll() {
    this.setFavorites([]);
  }

  isFavorite(itemId: any, type: string) {
    if (this.isParent(type)) {
      return this.parentExists(itemId);
    } else {
      return this.marketExists(itemId);
    }
  }

  isParent(type: string) {
    return ["EVENT", "RACE"].includes(type);
  }

  parentExists(parentId: any) {
    return this.favoriteItems.value.some((x: any) => x.id === parentId);
  }

  marketExists(marketId: any) {
    const allMarkets = this.favoriteItems.value.reduce<any[]>((acc, item) => [...acc, ...(item?.markets ?? [])], []);
    return allMarkets?.some((x: any) => x.id === marketId);
  }
}
